import { css, styled } from "goober";

export const Form = styled("form")`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  .edit-info {
    display: flex;
    flex-direction: column;
    gap: var(--sp-6);

    color: var(--shade1);
  }

  .dob {
    .dob-label {
      margin-bottom: var(--sp-2);
    }

    .dob-fields {
      display: flex;
      flex-direction: row;
      gap: var(--sp-3);

      & > *:first-child {
        flex: 1.5;
      }

      & > *:nth-child(2) {
        flex: 0.75;
      }
    }
  }

  .location-gender {
    display: flex;
    flex-direction: row;
    gap: var(--sp-3);

    .location {
      flex: 1;

      display: flex;
      flex-direction: column;

      .location-label {
        margin-bottom: var(--sp-2);
      }

      .location-field {
        height: var(--sp-11);
      }
    }

    .gender {
      display: flex;
      flex-direction: column;

      .gender-label {
        margin-bottom: var(--sp-2);
      }

      .gender-field {
        height: var(--sp-11);
      }
    }
  }

  footer {
    justify-content: flex-end;
  }
`;

export const cssInputError = () => css`
  position: absolute;
  bottom: var(--sp-6);

  padding-top: var(--sp-0_5);

  color: var(--primary);
  font-weight: 400;
  font-size: var(--sp-3);

  opacity: 0;

  transform: translateY(50%);

  transition:
    opacity 0.25s,
    transform 0.25s;

  &.shown {
    opacity: 1;

    transform: translateY(100%);
  }
`;
